//history is installed as dependency of react-router-dom
import { createBrowserHistory } from "history";
//used with Router, not the BroserRouter or similar..
const history = createBrowserHistory();
export default history;
